import { render, staticRenderFns } from "./merchant-footer.vue?vue&type=template&id=4b9f96aa&scoped=true&"
import script from "./merchant-footer.vue?vue&type=script&lang=js&"
export * from "./merchant-footer.vue?vue&type=script&lang=js&"
import style0 from "./merchant-footer.vue?vue&type=style&index=0&id=4b9f96aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9f96aa",
  null
  
)

export default component.exports